(function(){"use strict";}());

angular.module("app")
    .directive("helpView", ["AppService", "$document", "$timeout", "$rootScope" , function(AppService,$document, $timeout, $rootScope){

        return {
            restrict: "A",
            replace: false,
            templateUrl: "views/help.html",
            link: function($scope, element, attributes){
            	var trace = angular.trace;
            	var container = $document.find("*[data-help-target='"+$scope.currentHelp+"']");
            	var scale = $scope.preventScale ? 1 : $scope.currentScale;
            	var original = null;
            	var initialized = false;
            	$scope.helpItems = AppService.help[$scope.currentHelp];
            	$timeout(initialize,0);

            	function initialize(){
            		element.click(function(){
            			$scope.$apply($scope.dismissHelp);
            		});

            		original = element.html();
            		if(!$scope.preventScale) setScaledHelp();
            		//else setUnscaledHelp();

            		if($scope.preventScale) $scope.$watch("currentScale",function(){
            			$timeout(setUnscaledHelp,0);
            		});
            	}

            	function setUnscaledHelp(update){
            		if(initialized) {
            			element.find("p").each(function(){
            				//$(this).width(parseInt($(this).data("width")));
            				//$(this).height(parseInt($(this).data("height")));
            			});
            		}
            		else{
            			element.find("p").each(function(){
            				$(this).data("width",$(this).width());
            				$(this).data("height",$(this).height());
            				$(this).data("top",parseInt($(this).css("top")));
            				$(this).data("left",parseInt($(this).css("left")));
            			});
            			initialized = true;
            		}

            		for(var i = 0, count = $scope.helpItems.length; i < count; i++){
	            		var item = $scope.helpItems[i];
	            		var bubble = element.find("#"+item.id);
	            		var target = container.find("*[data-help='"+item.id+"']");
	            		var offset = target.offset();
	            		var top = element.offset().top;
	            		var left = element.offset().left;
	            		var dimensions = {width:target.outerWidth(),height:target.outerHeight()};
	            		var style = item.style = {top:0,left:0};
	            		var scaleFactorW = bubble.width()*$scope.currentScale;
	            		var scaleFactorH = bubble.height()*$scope.currentScale;

	            		//bubble.width(scaleFactorW);
	            		//bubble.height(scaleFactorH);
	            		//bubble.css("fontSize","1vw");
	            		
	            		//if(bubble.css("backgroundImage").match("small")) bubble.css("backgroundSize",bubble.outerWidth()+"px " + (bubble.outerHeight()*2)+"px");
	            		//else bubble.css("backgroundSize",(bubble.outerWidth()*2) + "px " + (bubble.outerHeight()) + "px");


	            		//offset.top = offset.top/scale - (top/scale);
	            		//offset.left = offset.left/scale - (left/scale);

	            		switch(item.position.v){
	            			case "top":
	            				style.top = offset.top - bubble.outerHeight();
	            			break;
	            			case "center":
	            				style.top = offset.top + dimensions.height/2 - bubble.outerHeight()/2;
	            			break;
	            			case "bottom":
	            				style.top = offset.top + dimensions.height;
	            			break;
	            			default:
	            		}
	            		switch(item.position.h){
	            			case "left":
	            				style.left = offset.left - bubble.outerWidth();//(offset.left - bubble.width() - bubblePaddingH);
	            			break;
	            			case "center":
	            				style.left = offset.left + dimensions.width/2 - (bubble.outerWidth())/2;
	            			break;
	            			case "right":
	            				style.left = offset.left + dimensions.width;
	            			break;
	            			default:
	            		}

	            		//item.style.top = item.style.top  + "px";
	            		//item.style.left = item.style.left + "px";
	            	}
            	}

            	function setScaledHelp(){
					for(var i = 0, count = $scope.helpItems.length; i < count; i++){
	            		var item = $scope.helpItems[i];
	            		var bubble = element.find("#"+item.id);
	            		var target = container.find("*[data-help='"+item.id+"']");
	            		var offset = target.offset();
	            		var top = element.offset().top;
	            		var left = element.offset().left;
	            		var dimensions = {width:target.width() + parseInt(target.css("paddingLeft")) + parseInt(target.css("paddingRight")),height:target.height() + parseInt(target.css("paddingTop"))+parseInt(target.css("paddingBottom"))};
	            		var style = item.style = {top:0,left:0};
	            		var bubblePaddingH = (parseInt(bubble.css("paddingLeft")) + (parseInt(bubble.css("paddingRight"))));
	            		var bubblePaddingV = (parseInt(bubble.css("paddingTop")) + (parseInt(bubble.css("paddingBottom"))));
	            		if(!offset) continue;
	            		offset.top = offset.top/scale - (top/scale);
	            		offset.left = offset.left/scale - (left/scale);

	            		switch(item.position.v){
	            			case "top":
	            				style.top = offset.top - bubble.height()-bubblePaddingV;
	            			break;
	            			case "center":
	            				style.top = offset.top + dimensions.height/2 - bubble.height()/2;
	            			break;
	            			case "bottom":
	            				style.top = offset.top + dimensions.height;
	            			break;
	            			default:
	            		}
	            		switch(item.position.h){
	            			case "left":
	            				style.left = offset.left - bubble.width() - bubblePaddingH;
	            			break;
	            			case "center":
	            				style.left = offset.left + dimensions.width/2 - (bubble.width()+bubblePaddingH)/2;
	            			break;
	            			case "right":
	            				style.left = offset.left + dimensions.width;
	            			break;
	            			default:
	            		}

	            		item.style.top = item.style.top  + "px";
	            		item.style.left = item.style.left + "px";
	            	}
            	}

            }
        };

    }]);
